module.exports = __webpack_public_path__ + "img/size4_en.f322c7c6.png";